import { render, staticRenderFns } from "./MpTemplateMessage.vue?vue&type=template&id=05011666&"
import script from "./MpTemplateMessage.vue?vue&type=script&lang=js&"
export * from "./MpTemplateMessage.vue?vue&type=script&lang=js&"
import style0 from "./MpTemplateMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports